export const iconFontAwesomeAlphabetF = (
	<i className="fa-solid fa-f"></i>
);
